import { Box, Tooltip, Typography } from '@mui/material'
import LocationIcon from '../../../assets/Icons/LocationIcon'
import DropDownV3 from '../../../common/DropDownV3'
import MButton from '../../../common/MButton'
import CustomDatePicker from '../../../common/CustomDatePicker'
import dayjs from 'dayjs'
import SwapIcon from '../../../assets/Icons/SwapIcon'
import { useDispatch, useSelector } from 'react-redux'
import { showErrorAlert } from '../../../redux/Actions'
import { getBusTrackingMapLink, getSearchRoutesBookBusTickets, getYourBusTracking, updateCallIntanglesAPI, updateCallTracknetAPI } from '../../../redux/Booking/BookingActions'
import CalendarIcon from '../../../assets/Icons/CalendarIcon'
import QuickSearchDate from './QuickSearchDate'
import {  allowdConductorNo, allowdDriverNo, allowedCompaniesPickUpName, tripDetailsFormat } from '../constant'
import { useLoadTripDetails } from '../../../hook/useLoadTripDetails'
import { checkAndFocus, focusElemnt, navigation3 } from '../../../utils/helpers'
import { useRecentSearch } from '../../../hook/useRecentSearch'
import { useHistoryCity } from '../../../hook/useHistoryCity'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import moment from 'moment'
const FilterSection = (props) => {
    const { bkgDeatails, filterOptions, filterValues, setFilterOptions, setFilterValues, setTableData, handleReset = () => { },
        handleResetTripData,
        setBkgDetails,
        setFilterOpt,
        setSelectedSeat,
    } = props;
    const dispatch = useDispatch();
    const store = useSelector((store) => store);
    const { loadTripDetails } = useLoadTripDetails();
    const { addRecentSearch, getRecentSearches } = useRecentSearch();
    const recentSearchData = getRecentSearches()

    const { user } = store;
    const { userDetails } = user;
    let checkGST = Object.keys(bkgDeatails.gstData).length > 0 && (bkgDeatails.gstData?.vendorId === 31 || bkgDeatails.gstData?.vendorId === 37 || bkgDeatails.gstData?.vendorId === 12 || bkgDeatails.gstData?.vendorId === 4) && moment().isSameOrAfter(moment(bkgDeatails?.gstData?.tripStartTime).subtract(30, "minutes"))

    const fromCityProps = () => {
        return {
            width: "100%",
            name: "fromCity",
            id: 'fromCity',
            label: "From (Alt + A)",
            isCompulsory: false,
            options: filterOptions?.fromCity || [],
            preSelectedValues: filterValues?.fromCity || [],
            searchPlaceholder: "Search by From ",
            disabled: false,
            isObject: true,
            primaryKey: 'FromCityID',
            labelKey: 'FromCityName',
            singleSelect: true,
            nextId: 'toCity',
            prevId: ``,

        }
    }

    const handleFromCity = (val) => {
        handleReset()
        let toCityList = filterOptions?.mainCity.filter((obj) => obj.FromCityID === val[0]?.FromCityID);
        setFilterOptions((prev) => ({
            ...prev,
            toCity: toCityList,
        }))
        setFilterValues((prev) => ({
            ...prev,
            fromCity: val,
            toCity: toCityList.length ? [toCityList[0]] : [],
        }))
    }
    const toCityProps = () => {
        return {
            width: "100%",
            name: "toCity",
            id: 'toCity',
            label: "To (Alt + T)",
            isCompulsory: false,
            options: filterOptions?.toCity || [],
            preSelectedValues: filterValues?.toCity || [],
            searchPlaceholder: "Search by To City",
            disabled: false,
            isObject: true,
            primaryKey: 'ToCityID',
            labelKey: 'ToCityName',
            singleSelect: true,
            nextId: 'journey_Date',
            prevId: `fromCity`,

        }
    }
    const handleToCity = (val) => {
        setFilterValues((prev) => ({
            ...prev,
            toCity: val,
        }))
        handleReset()
    }

    const handleSwap = () => {
        handleReset()

        const fromCity = filterValues?.fromCity || [];
        const toCity = filterValues?.toCity || [];
        let cityList = filterOptions?.mainCity;
        let defFromCity = cityList.filter((obj) => obj.FromCityID === toCity[0]?.ToCityID);
        let defToCity = []
        if (defFromCity.length > 0) {
            defToCity = defFromCity.filter((obj) => obj.ToCityID === fromCity[0]?.FromCityID);
        }

        setFilterValues((prev) => ({
            ...prev,
            fromCity: defFromCity.length ? [defFromCity[0]] : [],
            toCity: defToCity.length ? [defToCity[0]] : [defFromCity[0]],
        }))
        setFilterOptions((prev) => ({
            ...prev,
            toCity: defFromCity,
        }))
    }

    const handleSearch = (journeyDate = dayjs(), fromCity = [], toCity = [], isLastSearch = false) => {
        handleReset()
        if (fromCity.length === 0) {
            dispatch(showErrorAlert("Please select From City"));
        } else if (toCity.length === 0) {
            dispatch(showErrorAlert("Please select To City"));
        } else {
            const body = {
                intUserID: userDetails?.AgentUserID || 0,
                intFromCityID: fromCity[0]?.FromCityID,
                intToCityID: toCity[0]?.ToCityID,
                dtJDate: dayjs(journeyDate).format('YYYY-MM-DD'),
                intAgentID: userDetails?.AgentID || 0,
                strEntityType: 'A'
            }
            dispatch(getSearchRoutesBookBusTickets(body, false, 0)).then((res) => {
                if (res?.data?.status) {
                    let data = res?.data?.Data?.Table || {};
                    let tripData = tripDetailsFormat(data)
                    setTableData(tripData);
                    requestAnimationFrame(() => checkAndFocus(`trip-${0}`));
                    if (tripData.length > 0) {
                        handleTrip(tripData?.[0])
                        if (!isLastSearch) {
                            addRecentSearch(filterValues)
                        }
                    } else {
                        dispatch(showErrorAlert('No Trip Found'))
                    }
                } else {
                    dispatch(showErrorAlert(res?.data?.message))
                }
                console.log("Search Results:", res);
            }).catch((err) => {
                console.error("Search Error:", err);
            })
        }
    }



    const handleTrip = (trip) => {
        handleResetTripData()
        loadTripDetails({ tripDetails: trip, setBkgDetails, setFilterOpt, setSelectedSeat });
    }

    const { handleHistoryCity } = useHistoryCity({
        filterOptions,
        setFilterValues,
        setFilterOptions,
        handleSearch,
    });

    const handleGST = () => {
        let gstData = bkgDeatails.gstData
        if (gstData?.vendorId === 31) {
            const body = {
                vehiclenum: gstData?.masterBusNumber.replace(/-/g, ""),
                expirySeconds: Math.floor(new Date(gstData.tripEndTime).getTime() / 1000) + (30 * 60),
                intCompanyID: bkgDeatails?.tripDetails?.CompanyID,
            }
            dispatch(updateCallIntanglesAPI(body)).then((res) => {
                const resData = res.data;
                handleOpenMap(resData)
            })
        } else if (gstData?.vendorId === 37) {
            const body = {
                tracknetVehicleno: gstData?.masterBusNumber.replace(/-/g, ""),
                tracknettripStartTime: gstData?.tripStartTime,
                tracknettripEndTime: gstData?.tripEndTime,
                tracknetFrmCity: bkgDeatails?.tripDetails?.FromCityIDMain,
                tracknetToCity: bkgDeatails?.tripDetails?.ToCityIDMain,
                tracknetRouteName: bkgDeatails?.tripDetails?.RouteName.replace(/-/g, "to"),
                dtChartDate: moment(bkgDeatails?.tripDetails?.ChartDate, 'DD-MMMM-YYYY').format('YYYY-MM-DD'),
                _tracknetGpsToken: gstData?.TracknetGpsToken,
            }
            dispatch(updateCallTracknetAPI(body)).then((res) => {
                handleOpenMap(res.data)
            })
        } else if (gstData?.vendorId === 12) {
            const body = {
                GPSvehicleID: gstData.gpsVehicleId,
                Gpsvehiclenum: gstData?.masterBusNumber,
            }
            dispatch(getBusTrackingMapLink(body)).then((res) => {
                if (res.data.status) {
                    window.open(res.data.Data.Table?.[0]?.TrackingURL, "_blank")
                } else {
                    dispatch(showErrorAlert(res.data.Message))
                }
            })
        } else if (gstData?.vendorId === 4) {
            const body = {
                intTripID: bkgDeatails?.tripDetails?.TripID,
                intCompanyID: bkgDeatails?.tripDetails?.CompanyID,
            }
            dispatch(getYourBusTracking(body)).then((res) => {
                handleOpenMap(res?.data)
            })
        }
    }

    const handleOpenMap = (resData) => {
        if (typeof resData === "string" && resData.startsWith("ERROR")) {
            dispatch(showErrorAlert(resData));
        } else if (resData) {
            window.open(resData, "_blank");
        } else {
            dispatch(showErrorAlert("Unexpected response from server"));
        }
    }

    return (
        <>
            {(recentSearchData.length !== 0 || Object.keys(bkgDeatails.tripDetails).length !== 0) &&
                <Box className='history_service_section'>
                    <Box className='history_section'>
                        {recentSearchData.map((obj) => (
                            <Box onClick={() => {
                                handleHistoryCity(obj)
                            }}>
                                <Typography>{obj.source.FromCityNameShort}-{obj.destination.ToCityNameShort}</Typography>
                            </Box>
                        ))}
                    </Box>
                    <Box className='serviceName_lable'>
                        {(bkgDeatails?.tripDetails?.BusMasterNumber !== null && bkgDeatails?.tripDetails?.BusMasterNumber?.toString()?.trim() !== '') &&
                            <Tooltip
                                placement='top'
                                arrow
                                title={
                                    <div style={{ fontSize: '14px', padding: '4px 6px' }}>
                                        <div>
                                            <strong>Bus No:</strong>{' '}
                                            {bkgDeatails?.tripDetails?.BusMasterNumber?.split(/[,~]/)[0]}
                                        </div>
                                        <div>
                                            <strong>Driver:</strong>{' '}
                                            {`${bkgDeatails?.tripDetails.driverName || ''} ${allowdDriverNo.has(Number(bkgDeatails?.tripDetails.CompanyID)) ? `(${bkgDeatails?.tripDetails.driverContactNo || ''})` : ''}`}
                                        </div>
                                        <div>
                                            <strong>Conductor:</strong>{' '}
                                            {`${bkgDeatails?.tripDetails.ConductorName || ''} ${allowdConductorNo.has(Number(bkgDeatails?.tripDetails.CompanyID)) ? `(${bkgDeatails?.tripDetails.ConductorContact || ''})` : ''}`}
                                        </div>
                                        {allowedCompaniesPickUpName.has(Number(bkgDeatails?.tripDetails.CompanyID)) &&
                                            <div>
                                                <strong>PickUp Man:</strong>{' '}
                                                {`${bkgDeatails?.tripDetails.pickupMan || ''}${bkgDeatails?.tripDetails.pickupManContactNo ? `(${bkgDeatails?.tripDetails.pickupManContactNo || ''})` : ''}`}

                                            </div>
                                        }
                                    </div>
                                }
                            >
                                <Typography className='busMaster_blink'>
                                    {bkgDeatails?.tripDetails?.BusMasterNumber}
                                </Typography>
                            </Tooltip>
                        }
                        <Typography>
                            {bkgDeatails?.tripDetails?.ServiceName || ''}
                        </Typography>
                    </Box>
                </Box>
            }
            <Box className='filter_Section'>
                <Box className='filter_box'>
                    <Box className='filter_icon'>
                        <LocationIcon />
                    </Box>
                    <Box className='filter_dropDown'>
                        <DropDownV3
                            {...fromCityProps()}
                            onSelect={handleFromCity}
                        />
                    </Box>
                </Box>
                <Box className='swapIcon_box' sx={{ position: 'relative' }}>
                    <Box className="filter_swapIcon" onClick={handleSwap}>
                        <SwapIcon />
                    </Box>
                </Box>
                <Box className='filter_box' sx={{ padding: '4px 8px 4px 12px !important' }}>
                    <Box className='filter_icon'>
                        <LocationIcon />
                    </Box>
                    <Box className='filter_dropDown'>
                        <DropDownV3
                            {...toCityProps()}
                            onSelect={handleToCity}
                        />
                    </Box>
                </Box>
                <Box className='filter_box'>
                    <Box className='filter_icon'>
                        <CalendarIcon />
                    </Box>
                    <Box className='filter_datePicker'>
                        <CustomDatePicker label='Journey Date' id='journey_Date' selectedDate={filterValues?.journeyDate || dayjs()}
                            onChange={(date) => {
                                handleReset()
                                setFilterValues((prev) => ({
                                    ...prev,
                                    journeyDate: date,
                                }))
                                setTimeout(() => {
                                    focusElemnt('search_btn')
                                }, 500)

                            }}
                            minDate={dayjs(window.getTime ? window.getTime() : new Date())}

                            nextId='search_btn'
                            prevId='toCity'
                        />
                    </Box>
                </Box>
                <MButton btnName='Search' id='search_btn' className='btn-orange36'
                    onClick={() => {
                        handleSearch(filterValues?.journeyDate, filterValues?.fromCity, filterValues?.toCity)
                    }}
                    onKeyDown={(event) => {
                        if (event.key === "Enter") {
                            handleSearch(filterValues?.journeyDate, filterValues?.fromCity, filterValues?.toCity)
                        }
                        navigation3(event, "", 'journey_Date', () => {
                            handleSearch(filterValues?.journeyDate, filterValues?.fromCity, filterValues?.toCity)
                        })
                    }}
                />
                <Box className={`gps_icon ${checkGST ? 'activeGSP' : ''}`}
                    onClick={() => {
                        if (checkGST) {
                            handleGST()
                        }
                    }}
                >
                    {checkGST ?
                        <LocationOnIcon />
                        :
                        <LocationOffIcon />
                    }

                </Box>
            </Box>
            <QuickSearchDate filterValues={filterValues} setFilterValues={setFilterValues} handleSearch={(journeyDate) => {
                handleSearch(journeyDate, filterValues?.fromCity, filterValues?.toCity)
            }} />
        </>
    )
}

export default FilterSection